<template>
  <div class="container sv045">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne>お申し込み条件・お手続きの流れ</HeadingOne>

    <p class="_mb-md-60 _mb-sm-40">
      パソコン・スマートフォンから24時間365日お申し込みが可能です！お申し込みからお借り入れまでの流れをご説明します。
    </p>

    <section class="_mb-md-120 _mb-sm-60">
      <HeadingTwo>お申し込み条件</HeadingTwo>
      <ListGroup class="-normal">
        <ListItem class="-normal">ご本人さま名義のau IDをお持ちのお客さま（法人契約でご利用のau IDではお申込みいただけません）</ListItem>
        <ListItem class="-normal">満20歳以上、70歳以下のお客さま</ListItem>
        <ListItem class="-normal">ご本人さまに定期収入のある方</ListItem>
        <ListItem class="-normal">携帯電話をお持ちのお客さま</ListItem>
        <ListItem class="-normal">現住所が国内にある方</ListItem>
      </ListGroup>

      <ListGroup class="-note">
        <ListItem class="-note">年金を受給されている場合は、年金以外に安定した収入がある方に限ります。</ListItem>
        <ListItem class="-note -red">ご利用時にSMSの追加認証がございます。</ListItem>
        <ListItem class="-note">au PAY カードをお持ちで、キャッシングサービス/キャッシング月々返済（カードローン）をお申し込み中、またはすでに設定されている方は、お申し込みいただけない場合がございます。</ListItem>
      </ListGroup>
    </section>

    <section>
      <StepList type="sv" class="-orange">
        <HeadingTwo>お申し込みの流れ</HeadingTwo>
        <StepItem
          number="1"
          title="お客さま情報のご入力"
          src="sv/sv045/img01.jpg"
        >
          <p>
            au
            IDに登録されているお客さま情報が自動で反映されるため、少ないご入力項目でかんたんにお申し込みできます。
          </p>
        </StepItem>
        <StepItem
          number="2"
          title="インターネットで口座のご登録"
          src="sv/sv045/img02.jpg"
        >
          <p>
            お借り入れ・ご返済の際にご利用いただく金融機関口座をご登録していただきます。本手続きで口座の登録と合わせてご本人さま確認とさせていただきます。
          </p>
          <ListGroup class="-link _mt-md-20">
            <ListItem class="-link" router-name="sv018"
              >ご利用可能な金融機関について</ListItem
            >
          </ListGroup>
          <ListGroup class="-note">
            <ListItem class="-note"
              >口座のご登録ができないお客さまは、ご本人さま確認書類のアップロードが必要となります。その場合、ご契約に必要な「確認コード」が記載されたハガキを簡易書留で郵送しますので、ご契約までに１週間程度お時間がかかります。</ListItem
            >
          </ListGroup>
          <ListGroup class="-link _mt-md-20">
            <ListItem class="-link" router-name="sv019"
              >ご本人さま確認書類について</ListItem
            >
            <ListItem class="-link" router-name="sv057"
              >収入証明書について</ListItem
            >
          </ListGroup>
          <ListGroup class="-note">
            <ListItem class="-note"
              >当社でのご利用限度額が50万円を超える場合、または当社でのご利用限度額と他の貸金業者からのお借り入れ残高の合計が100万円を超える場合は、ご契約前に収入証明書のご提出をお願いする場合がございます。</ListItem
            >
          </ListGroup>
        </StepItem>
        <StepItem
          number="3"
          title="審査完了をメールでご連絡（お申し込み完了から最短30分※）"
          src="sv/sv045/img03.jpg"
        >
          <p>
            メールに記載されているURLより審査結果ご確認ページへアクセスしてください。審査結果確認後、ご融資可能なお客さまはそのままご契約手続きとなります。
          </p>
          <ListGroup class="-link _mt-md-20">
            <ListItem class="-link" router-name="ce001"
              >今すぐ審査状況を確認する</ListItem
            >
          </ListGroup>
          <ListGroup class="-note">
            <ListItem class="-note"
              >お申し込みの時間帯や審査状況によっては、翌日以降のご連絡となる場合がございます。</ListItem
            >
          </ListGroup>
        </StepItem>
        <StepItem
          number="4"
          title="審査結果確認～ご契約手続き"
          src="sv/sv045/img04.jpg"
          class="-last"
        >
          <p>
            WEBサイト上でご契約内容をご確認いただきます。ご契約締結後、すぐにお借り入れが可能です。
          </p>
        </StepItem>

        <StepFooter badge="ご契約当日から可能！">
          <template #heading>お借り入れ</template>
        </StepFooter>

        <div class="step-box">
          <div class="step-img _mr-md-20">
            <img
              src="@/assets/images/sv/sv045/img05.jpg"
              class="img-fluid"
              alt=""
            />
          </div>
          <div class="step-txt _ml-md-20">
            <p>
              パソコン・スマートフォンがあればいつでも、どこでもお借り入れが可能です。<br />au
              PAY 残高にチャージすれば、au PAY プリペイドカードやau
              PAYとして使えてポイントもたまるのでさらにおトクです！
            </p>
            <ListGroup class="-link _mt-md-20">
              <ListItem class="-link" router-name="sv046"
                >お借り入れ方法について</ListItem
              >
              <ListItem class="-link" router-name="sv024"
                >au PAY 残高へのチャージ（お借り入れ）について</ListItem
              >
            </ListGroup>
          </div>
        </div>
        <ListGroup class="-note _mt-md-20 _mb-md-110 _mb-sm-60">
          <ListItem class="-note"
            >「確認コード」が記載されたハガキは、ご登録住所あてに「転送不要」の簡易書留または、本人限定受取郵便にてお送りさせていただきますので、お受け取りください。なお、郵便には保管期限がございますので、ご注意ください。</ListItem
          >
          <ListItem class="-note"
            >お申し込み内容により、お手続きにお時間がかかる場合や、ご希望に添えない場合がございます。</ListItem
          >
          <ListItem class="-note"
            >お申し込み内容や在職確認等のため、お電話させていただく場合がございます。</ListItem
          >
        </ListGroup>
      </StepList>
    </section>

    <CvBox class="_mb-md-120 _mb-sm-60" />

    <!--<div class="row">-->
    <!--<card-link class="col-md-6 _mb-md-120 _mb-sm-60" title="新規お申し込みに必要な書類" src="sv/sv045/img06.jpg" router-name="sv001" badge="">-->
    <!--ご利用可能な本人確認書類や、ご提出時のご注意についてはこちらをご参考ください。-->
    <!--</card-link>-->
    <!--</div>-->

    <ContactBox class="_mb-md-120 _mb-sm-60" />
  </div>
  <!-- container -->
</template>

<script>
import HeadingOne from "@/components/heading/HeadingOne";
import HeadingTwo from "@/components/heading/HeadingTwo";
import StepList from "@/components/steps/StepList";
import StepItem from "@/components/steps/StepItem";
import StepFooter from "@/components/steps/StepFooter";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import CvBox from "@/components/box/CvBox";
import ContactBox from "@/components/box/ContactBox";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import { setMeta } from "@/utils/Meta";

export default {
  name: "Sv045",
  components: {
    ContactBox,
    CvBox,
    ListGroup,
    ListItem,
    HeadingOne,
    HeadingTwo,
    StepList,
    StepItem,
    StepFooter,
    BreadcrumbGroup,
  },
  setup() {
    setMeta({
      title: "お申し込み条件・お手続きの流れ",
      description:
        "au PAY スマートローンのご入会について、お申し込み条件や、新規お申し込みからお借り入れまでの流れ等分かりやすくご説明します。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,お申込み",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "root",
        },
        {
          text: "お申し込み条件・お手続きの流れ",
          active: true,
        },
      ],
      check: {
        expectation: "",
      },
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.list-group {
  > .list-item {
    > .badge-icon {
      padding-left: 15px !important;
      padding-right: 15px !important;
      @include mq-up(md) {
        padding-left: 20px !important;
        padding-right: 20px !important;
        margin-left: 10px;
      }
    }
  }
}
.step-box {
  @include mq-up(md) {
    display: flex;
  }
  > .step-img {
    max-width: 100%;
    @include mq-up(md) {
      max-width: 44.5%;
    }
  }
  > .step-txt {
    max-width: 100%;
    @include mq-up(md) {
      max-width: 55.5%;
    }
  }
}
.-red {
  color: $danger;
}
</style>
